import { Link } from "react-router-dom";
import { BroadcastIcon, BuildingsIcon, UsersThreeIcon, CaretDownIcon, ArrowRightIcon } from "@phosphor-icons/react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";

export const ORG_LINKS = [
  { to: "/newsrooms", label: "Newsrooms & Publishers", desc: "Citable data, live embeds, licensing", Icon: BroadcastIcon, testid: "orgs-newsrooms", tint: "#38bdf8" },
  { to: "/embi-gov", label: "Virginia Public Institutions", desc: "EMBI-Gov private workspaces", Icon: BuildingsIcon, testid: "orgs-gov", tint: "#26F195" },
  { to: "/associations", label: "Trade & Professional Associations", desc: "Custom intelligence indices", Icon: UsersThreeIcon, testid: "orgs-associations", tint: "#f5b544" },
];

function Tiles() {
  return (
    <span className="flex -space-x-1.5" aria-hidden="true">
      {ORG_LINKS.map(({ to, Icon, tint }) => (
        <span key={to} className="w-5 h-5 rounded-full grid place-items-center border border-[#061025]" style={{ background: `${tint}26` }}>
          <Icon size={11} weight="bold" style={{ color: tint }} />
        </span>
      ))}
    </span>
  );
}

export function OrgsMenu({ active }) {
  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="nav-orgs" aria-label="For Organizations — choose from 3 audiences"
        className={`group ml-1 pl-2 pr-3 py-1.5 rounded-lg flex items-center gap-2 border text-[13px] font-semibold text-zinc-100 transition-colors outline-none data-[state=open]:bg-signal/15 data-[state=open]:border-signal/60 ${active ? "border-signal/60 bg-signal/15" : "border-signal/30 bg-signal/[0.06] hover:bg-signal/12 hover:border-signal/50"}`}>
        <Tiles />
        For Organizations
        <span className="font-mono text-[10px] text-signal/90 bg-signal/10 rounded px-1 py-px">3</span>
        <CaretDownIcon size={12} weight="bold" className="text-signal transition-transform group-data-[state=open]:rotate-180" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" sideOffset={8} className="w-[22rem] bg-[#0A0F1E] border-zinc-800 p-2 shadow-2xl shadow-black/50" data-testid="orgs-menu">
        <div className="px-2 pt-1 pb-2 font-mono text-[10px] uppercase tracking-[0.2em] text-zinc-500">Choose your path · 3 audiences</div>
        {ORG_LINKS.map(({ to, label, desc, Icon, testid, tint }) => (
          <DropdownMenuItem key={to} asChild className="group/item focus:bg-white/[0.04] cursor-pointer rounded-lg p-0 mb-1 last:mb-0">
            <Link to={to} data-testid={testid}
              className="flex items-center gap-3 px-2.5 py-2.5 no-underline border border-transparent hover:border-zinc-700 rounded-lg transition-colors"
              style={{ borderLeft: `3px solid ${tint}` }}>
              <span className="w-9 h-9 rounded-lg grid place-items-center shrink-0" style={{ background: `${tint}1f` }}>
                <Icon size={19} weight="duotone" style={{ color: tint }} />
              </span>
              <span className="flex flex-col flex-1 min-w-0">
                <span className="text-[13.5px] font-semibold text-zinc-100">{label}</span>
                <span className="text-[11.5px] text-zinc-500">{desc}</span>
              </span>
              <ArrowRightIcon size={14} weight="bold" className="text-zinc-600 transition-transform group-hover/item:translate-x-0.5 group-focus/item:translate-x-0.5" />
            </Link>
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
